<template>
  <base-top-bar @back="backHandler">
    <h1 slot="text">{{ carName }}</h1>
    <v-popover offset="16" placement="bottom">
      <button class="share">
        {{ $t("shared.share") }}
        <share-icon class="share__icon" :alt="$t('shared.share')" />
      </button>
      <template slot="popover">
        <social-sharing
          :url="currentPage"
          :title="title"
          :description="description"
          :quote="description"
          :media="carImageUrl"
          hashtags="hyundai, usedcars"
          network-tag="div"
          inline-template
        >
          <div>
            <network class="social-link" network="facebook">
              {{ $t("shared.facebook") }}
              <div class="social-link__icon">
                <facebook-icon />
              </div>
            </network>
            <network class="social-link" network="twitter">
              {{ $t("shared.twitter") }}
              <div class="social-link__icon">
                <twitter-icon />
              </div>
            </network>
            <network class="social-link" network="email">
              {{ $t("shared.email") }}
              <div class="social-link__icon">
                <email-icon />
              </div>
            </network>
          </div>
        </social-sharing>
      </template>
    </v-popover>
  </base-top-bar>
</template>

<script>
import { VPopover } from "v-tooltip";
import SocialSharing from "vue-social-sharing";
import BaseTopBar from "@/components/ui/BaseTopBar/BaseTopBar.vue";
import ShareIcon from "@/assets/images/share.svg";
import { CLEAR_CAR_INFO } from "@/store/mutationTypes";

export default {
  name: "ResultsTopBar",
  components: {
    VPopover,
    SocialSharing,
    BaseTopBar,
    ShareIcon
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    carName: {
      type: String,
      required: true
    },
    carImageUrl: {
      type: String,
      default: ""
    }
  },
  computed: {
    currentPage() {
      return window.location.href;
    }
  },
  methods: {
    backHandler() {
      this.$store.commit(CLEAR_CAR_INFO);
      if (this.$route.params.redirectByClick) return this.$router.go(-1);

      if (this.$route.name === "dealerDetails")
        return this.$router.push(
          `/dealer/${this.$route.params.dealerName}/results`
        );

      return this.$router.push("/results");
    }
  }
};
</script>

<style lang="scss">
.share {
  display: flex;
  color: $color-grey-400;
  padding: 0 10px;

  &:focus,
  &:hover {
    color: $color-black;
  }

  &__icon {
    margin-left: 20px;
  }
}

.social-link {
  display: flex;
  color: $color-grey-400;
  justify-content: space-between;
  padding: 12px 0;
  cursor: pointer;

  &:hover {
    color: $color-black;
  }

  &__icon {
    @include flex-centered();

    width: 15px;
  }
}
</style>
